module.exports = __webpack_public_path__ + "media/incorrect.e450d4d8.mp3";